import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "World Franchise Forum";
const DEFAULT_DESC =
  "The AI-refreshed global directory of franchise & licensing shows across 16+ countries — US, UK, UAE, Malaysia, Indonesia & India.";
const DEFAULT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/6f6a7888-12d8-4a7f-8d9c-f9684ebea278/images/1c8aa4d577dd0e3e1dc9b3d846ab48bbcbb333d50b57fa3f96d04ad34fbf3464.jpeg";

export const Seo = ({ title, description, image, path }) => {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Global Franchise Show Directory`;
  const desc = description || DEFAULT_DESC;
  const base =
    process.env.REACT_APP_PUBLIC_SITE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "");
  const relPath = path || (typeof window !== "undefined" ? window.location.pathname : "");
  const url = base ? `${base.replace(/\/$/, "")}${relPath}` : undefined;
  const img = image || DEFAULT_IMG;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};
